export const LOGS_BACKEND_URL = "https://logs.reclaimprotocol.org"
export const APP_BACKEND_URL = "https://api.reclaimprotocol.org"